"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableSearch = void 0;
const react_1 = require("react");
const predicate_language_1 = require("@groupby/predicate-language");
const debounce_1 = __importDefault(require("debounce"));
const constants_1 = require("../../constants");
const selectors_1 = require("../../store/selectors");
const useTableSearch = (searchableFields, setLastSelectedRowId) => {
    const selectedOrganizationsIds = (0, selectors_1.useSelectedOrganizationsIdsSelector)();
    const [searchQuery, setSearchQuery] = (0, react_1.useState)('');
    const [searchFilter, setSearchFilter] = (0, react_1.useState)(new predicate_language_1.PredicateBuilder());
    const handleSearch = (0, react_1.useCallback)((0, debounce_1.default)((query) => {
        const updatedFilter = new predicate_language_1.PredicateBuilder();
        const pattern = new RegExp(query, 'gi');
        searchableFields.forEach((field) => updatedFilter.or((0, predicate_language_1.where)((0, predicate_language_1.f) `${field}`, '=~', pattern)));
        setSearchFilter(updatedFilter);
    }, constants_1.SEARCH_QUERY_UPDATE_DELAY), []);
    const handleSearchProduct = (search) => {
        setLastSelectedRowId(null);
        setSearchQuery(search);
    };
    (0, react_1.useEffect)(() => {
        if (searchQuery) {
            handleSearch(searchQuery);
        }
        else {
            // skip debouncing
            setSearchFilter(new predicate_language_1.PredicateBuilder());
        }
    }, [searchQuery, handleSearch]);
    (0, react_1.useEffect)(() => {
        setSearchQuery('');
    }, [selectedOrganizationsIds]);
    return {
        handleSearch: handleSearchProduct,
        searchFilter,
        searchQuery,
    };
};
exports.useTableSearch = useTableSearch;
exports.default = exports.useTableSearch;
